import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppBar, Toolbar, Typography, Container, Box } from '@mui/material';
import { LocalHospital, Phone, LocationOn, Schedule } from '@mui/icons-material';

// Páginas
import Home from './pages/Home';
import Services from './pages/Services';
import Team from './pages/Team';
import Testimonials from './pages/Testimonials';
import Contact from './pages/Contact';
import Appointment from './pages/Appointment';

// Componentes
import Navigation from './components/Navigation';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      main: '#d8ad82',
    },
    secondary: {
      main: '#4caf50', // Verde salud
    },
    background: {
      default: '#fafafa',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <AppBar position="static" elevation={0} sx={{ backgroundColor: 'white', color: 'text.primary' }}>
            <Toolbar>
              <Box sx={{ display: 'flex', alignItems: 'center', mr: 2 }}>
              </Box>
              <Navigation />
            </Toolbar>
          </AppBar>

          <Container component="main" sx={{ flexGrow: 1}}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/equipo" element={<Team />} />
              <Route path="/testimonios" element={<Testimonials />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/citas" element={<Appointment />} />
            </Routes>
          </Container>

          <Footer />
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
